export enum AppTypes {
    // BAE with Model Designer
    STANDARD = 'standard',

    // Digital-Twin Specialized Apps
    GLOBAL_FABRIC = 'global-fabric',
    MIST = 'juniper-mist',
}
